export default __webpack_public_path__ + "static/media/service-1.a4d860ab.png";